<!--
  Landingpage „Honigautomat“. Winkel: Imker-Direktvermarktung, ganzjährig
  lagerfähig, Schritt vom LEH in den Eigenvertrieb. Referenz: Honigmanufaktur
  mit Herz (Live + Video).
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🍯</div>
      <span class="lp-eyebrow" i18n="@@honig.hero.eyebrow">Imkerei · Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@honig.hero.h1">Honigautomat kaufen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@honig.hero.lead">
        Verkaufe Honig rund um die Uhr – direkt ab Imkerei, ohne Standdienst und ohne Kühlung.
        Die <span class="tm">marktbox</span> bringt dich vom Verkauf über den Handel zum eigenen Vertrieb
        mit voller Preishoheit.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@honig.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#vorteile" (click)="scrollTo($event, 'vorteile')" i18n="@@honig.hero.ctaAnchor">Warum es sich lohnt ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Honigautomat für die Direktvermarktung ab Imkerei" i18n-alt="@@honig.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@honig.hero.badge">🐝 direkt vom Imker</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section id="vorteile" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@honig.adv.h2">Warum die marktbox als Honigautomat?</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🗓️</span>
        <h3 i18n="@@honig.adv1.h3">Ganzjährig haltbar</h3>
        <p i18n="@@honig.adv1.p">Honig braucht keine Kühlung und ist lange lagerfähig – perfekt für den ungekühlten Automaten.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🏷️</span>
        <h3 i18n="@@honig.adv2.h3">Volle Preishoheit</h3>
        <p i18n="@@honig.adv2.p">Ein Schritt vom Verkauf über den Handel hin zum eigenen Vertrieb – du bestimmst den Preis.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🕒</span>
        <h3 i18n="@@honig.adv3.h3">24/7 ohne Standdienst</h3>
        <p i18n="@@honig.adv3.p">Kundschaft holt sich Honig, wann sie will – am Bienenstand, Hof oder an der Straße.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📈</span>
        <h3 i18n="@@honig.adv4.h3">Planbar &amp; skalierbar</h3>
        <p i18n="@@honig.adv4.p">Feste Portionen als Standardprozess verpackt und in die Fächer geladen – das macht den Verkauf planbar und einfach skalierbar, Box für Box.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Video: Honigmanufaktur (Facade) ===== -->
<section class="lp-section">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@honig.video.eyebrow">Aus der Praxis · Kooperation</span>
      <h2 class="lp-h2" i18n="@@honig.video.h2">Zu Gast in der Honigmanufaktur</h2>
      <p class="lp-lead" i18n="@@honig.video.lead">
        Gemeinsam mit der Honigmanufaktur mit Herz zeigen wir, wie Honig-Direktvermarktung mit der
        marktbox in der Praxis funktioniert – nah an der Kundschaft, rund um die Uhr.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@honig.video.cta">Automat konfigurieren</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: Zu Gast in der Honigmanufaktur mit Herz" i18n-aria-label="@@honig.video.aria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Zu Gast in der Honigmanufaktur mit Herz" i18n-title="@@honig.video.title"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Live-Link: Honigmanufaktur ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@honig.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@honig.live.h2">Sieh, welcher Honig gerade da ist</h2>
      <p class="lp-lead" i18n="@@honig.live.lead">
        Jede marktbox hat ihren eigenen Live-Link – hier am Beispiel der Honigmanufaktur mit Herz.
        Kundschaft sieht in Echtzeit, was verfügbar ist.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@honig.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@honig.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@honig.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@honig.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Honigmanufaktur mit Herz: Echtzeit-Verfügbarkeit" i18n-title="@@honig.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@honig.live.cap">Live-Beispiel: Honigmanufaktur mit Herz</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@honig.price.h2">Honigautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@honig.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@honig.price.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den festen Standplatz.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@honig.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@honig.price.rentText">Planbare Kosten, niedrige Einstiegshürde – gut zum Starten in einer Saison.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@honig.price.cta">Zum Shop – Honigautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@honig.price.fine">
      Lohnt sich das? <a [routerLink]="['/', links.blog, blogSlug]">Ratgeber: Warum sich ein Honigautomat lohnt</a>
    </p>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@honig.faq.h2">Häufige Fragen zum Honigautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@honig.final.h2">Bereit für deinen Honigautomaten?</h2>
    <p class="lp-lead" i18n="@@honig.final.lead">Ganzjährig, ohne Standdienst, mit voller Preishoheit – finde dein Modell.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@honig.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
